import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CompanionArena from './CompanionArena';

interface CompanionArenaModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CompanionArenaModal: React.FC<CompanionArenaModalProps> = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence key="companion-arena-modal">
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-2 sm:p-4 modal-container"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            className="bg-white rounded-xl shadow-2xl w-full max-w-7xl max-h-[98vh] overflow-hidden modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header - Kompakter auf Mobile */}
            <div className="sticky top-0 bg-gradient-to-r from-red-600 to-orange-600 text-white p-2 sm:p-3 md:p-4 flex justify-between items-center rounded-t-xl z-10">
              <h1 className="text-base sm:text-lg md:text-2xl font-bold flex items-center gap-1 sm:gap-2">
                <span className="text-lg sm:text-xl md:text-2xl">⚔️</span>
                <span className="hidden sm:inline">Arena-Kämpfe</span>
                <span className="sm:hidden">Arena</span>
              </h1>
              <button
                onClick={onClose}
                className="text-white hover:text-gray-200 transition-colors duration-200 text-lg sm:text-xl md:text-2xl p-1 sm:p-2 touch-manipulation min-h-[32px] sm:min-h-[40px] md:min-h-[44px] min-w-[32px] sm:min-w-[40px] md:min-w-[44px] flex items-center justify-center rounded-lg hover:bg-white/10"
              >
                ✕
              </button>
            </div>

            {/* Content - Passt sich an den Inhalt an */}
            <div className="overflow-y-auto max-h-[calc(98vh-80px)] modal-content">
              <CompanionArena />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CompanionArenaModal; 